<app-nav-menu></app-nav-menu>
<p-toast></p-toast>
<p-confirmDialog [closable]="false">
  <ng-template pTemplate="message" let-message>
    <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
      <i class="pi pi-exclamation-circle text-6xl text-primary-500"></i>
      <p>{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmDialog>
<p-dialog header="Passenger Details" [modal]="true" [(visible)]="popup" [style]="{ width: '25rem' }">
  <form #passengerForm="ngForm" (ngSubmit)="UpdateOfflineTicketRequest()">
    <div class="d-flex justify-content-end mb-2">
      <p-button label="Add New" icon="pi pi-plus" (click)="addNewPassenger()"></p-button>
    </div>

    @for (passenger of offlineObj.passengerList; track passenger; let i = $index) {
      <div>
        @if (!passenger.isDeleted) {
          <div class="row m-0">
            <div class="col-md-12">
              <div class="row m-0">
                <div class="col-md-6  mb-2 p-0 pl-2">  <h6>Passenger {{ i + 1 }}</h6></div>
                <div class="col-md-6  mb-2 p-0 pl-2">
                  @if (i > 0) {
                    <i class="pi pi-trash text-danger mt-2" (click)="removePassenger(i)" style="cursor:pointer"></i>
                  }
                </div>
              </div>
            </div>
            <div class="col-md-6  mb-2 p-0 pl-2" style="position: relative;">
              <label for="name{{i}}" [ngClass]=" !passenger.fullName?'labelofmodifyserachinputsError':'labelofmodifyserachinputs'">Passenger Name</label>
              <input class="inputStyle"
                [(ngModel)]="passenger.fullName"
                name="fullName{{i}}"
                #fullName="ngModel" [ngClass]="{'invalid-Error':  !passenger.fullName}"
                id="name{{i}}"
                autocomplete="off"
                required />
                @if (fullName.invalid && fullName.touched) {
                  <small class="text-danger">
                    Passenger name is required
                  </small>
                }
              </div>
              <!-- Passenger Type (Dropdown) -->
              <div class="col-md-6  mb-2 p-0 pl-2" style="position: relative;">
                <label for="type{{i}}" [ngClass]=" !passenger.type?'labelofmodifyserachinputsError':'labelofmodifyserachinputs'">Passenger Type</label>
                <select #type="ngModel" type="text" [(ngModel)]="passenger.type" class="inputStyle" required autocomplete="off" [ngClass]="{'invalid-Error':  !passenger.type}"
                  name="passtype{{i}}">
                  <option>
                    Adult
                  </option>
                  <option>
                    Child
                  </option>
                  <option>
                    Infant
                  </option>
                </select>
                @if (type.invalid && type.touched) {
                  <small class="text-danger">
                    Passenger type is required
                  </small>
                }
              </div>
              <!-- Ticket Number -->
              <div class="col-md-6  mb-2 p-0 pl-2" style="position: relative;">
                <label for="ticketno{{i}}" [ngClass]=" !passenger.ticketNo?'labelofmodifyserachinputsError':'labelofmodifyserachinputs'">Ticket Number</label>
                <input [ngClass]="{'invalid-Error':  !passenger.ticketNo}"
                  [(ngModel)]="passenger.ticketNo"
                  name="ticketNo{{i}}"
                  #ticketNo="ngModel"
                  id="ticketno{{i}}"
                  type="text"
                  class="inputStyle"
                  autocomplete="off"
                  required />
                  @if (ticketNo.invalid && ticketNo.touched) {
                    <small class="text-danger">
                      Ticket number Required!
                    </small>
                  }
                </div>
              </div>
            }
          </div>
        }

        <!-- Submit Button -->
        <div class="d-flex justify-content-end" style="gap: .5rem">
          <p-button label="Submit" type="submit" [disabled]="passengerForm.invalid"></p-button>
        </div>
      </form>
    </p-dialog>

    <p-dialog header="Enter PNR" [modal]="true" [(visible)]="popupPNR" [style]="{ width: '25rem' }">
      <form #pnrForm="ngForm" (ngSubmit)="UpdateOfflineRequest(4)">
        <div class="row m-0">
          <div class="col-md-6  mb-2 p-0 pl-2" style="position: relative;">
            <label for="pnr" [ngClass]=" !offlineObj.pnr?'labelofmodifyserachinputsError':'labelofmodifyserachinputs'">PNR</label>
            <input [ngClass]="{'invalid-Error':  !offlineObj.pnr}" (input)="offlineObj.pnr = offlineObj.pnr.toUpperCase()"
              [(ngModel)]="offlineObj.pnr"
              name="pnr"
              #pnr="ngModel"
              id="pnr"
              type="text"
              class="inputStyle"
              autocomplete="off"
              required />
              @if (pnr.invalid && pnr.touched) {
                <small class="text-danger">
                  Ticket number Required!
                </small>
              }
            </div>
          </div>


          <div class="d-flex justify-content-end" style="gap: .5rem">
            <p-button label="Submit" type="submit" [disabled]="pnrForm.invalid"></p-button>
          </div>
        </form>
      </p-dialog>
      @if (loader) {
        <div style="width: 100%; height: 105vh; position: fixed; background: #e8e8e8de; z-index: 500;top:0 ">
          <div class="text-center" style="width: 100%; display: flex; justify-content: center; align-items: center; text-align: center; height: 100%; }">
            <div class="spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      }
      <div style="width:100%;display:flex;">
        <p-dialog header="Request Flight Details" [style]="{width: '40vw'}" [draggable]="false" [resizable]="false" [dismissableMask]="true" [modal]="true" [(visible)]="popupDepdetails">
          <div style="padding:8px">





            <div class="flight-card">
              <div class="departure-container">
                <div class="departure-label">{{offlineObj.tripType}}</div>
                <div class="departure-date">Required Flight Information</div>
              </div>
              <div class="header">
                <!--<div class="airline-info">
                <img src="https://via.placeholder.com/40" alt="Avianca Logo" class="airline-logo">
                <div>
                  <h3 class="flight-number">AV 121</h3>
                  <p class="airline-name">Avianca</p>
                </div>
              </div>-->
              <div class="extras">
                <div style="font-size:10px;display:flex;flex-direction:column;">
                  <div style="font-size:12px;font-weight:bold">Criteria Filter</div>
                  <div> @if (offlineObj.isLcc) {
                    <span style="color:green">✔️</span>
                    } @if (!offlineObj.isLcc) {
                    <span style="color:red">✖️</span>
                  }Low cost</div>
                  <div> @if (offlineObj.isGds) {
                    <span style="color:green">✔️</span>
                    } @if (!offlineObj.isGds) {
                    <span style="color:red">✖️</span>
                  }GDS</div>

                  <div> @if (offlineObj.isNearByAirport) {
                    <span style="color:green">✔️</span>
                    } @if (!offlineObj.isNearByAirport) {
                    <span style="color:red">✖️</span>
                  }NearBy Airport</div>
                  <div> @if (offlineObj.isDirect) {
                    <span style="color:green">✔️</span>
                    } @if (!offlineObj.isDirect) {
                    <span style="color:red">✖️</span>
                  }Direct</div>
                </div>
                <div class="business" style="display:flex;flex-direction:column">

                  <span style="font-size:12px;font-weight:bold">Fare Type</span>
                  <span style="font-size:11px;">{{offlineObj.fareType}}</span>

                </div>
                <div class="business" style="display:flex;flex-direction:column">
                  <span style="font-size:12px;font-weight:bold">Cabin Class</span>
                  <span style="font-size:11px;">{{offlineObj.cabinClass}}</span>
                </div>
                <div class="bags" style="display:flex;flex-direction:column">
                  <div style="font-size:12px;font-weight:bold">
                    Passengers:
                  </div>
                  <div style="font-size:11px;">
                    {{offlineObj.adult}} Adult
                  </div>
                  <div style="font-size:11px;">
                    {{offlineObj.child}} Child
                  </div>
                  <div style="font-size:11px;">
                    {{offlineObj.infant}} Infant
                  </div>
                </div>
                <div class="bags" style="display:flex;flex-direction:column">
                  <div style="font-size:12px;font-weight:bold">
                    Preffered Airlines:
                  </div>
                  @for (pref of offlineObj.prefferedAirlines; track pref) {
                    <div style="font-size:11px;">
                      {{pref}}
                    </div>
                  }

                </div>
              </div>
            </div>
            @for (sec of offlineObj.sectorInfo; track sec; let i = $index) {
              <div class="flight-details">
                <div class="flight-time">
                  <p class="time">{{sec.fromCity}}</p>
                  <p class="airport">{{sec.fromAirport}}</p>
                  <p class="date">{{sec.departureDate | date:'y MMM d'  }}</p>
                </div>
                <div class="flight-duration">
                  <div class="animation-container">
                    <div class="airplane">✈️</div>
                    <div class="dashed-line"></div>
                  </div>
                  <!--<p class="duration">10h 10m</p>-->
                </div>
                <div class="flight-time">
                  <p class="time">{{sec.toCity}}</p>
                  <p class="airport">{{sec.toAirport}}</p>
                  <p class="date">{{sec.departureDate | date:'y MMM d'}}</p>
                </div>
              </div>
            }
          </div>

        </div>


      </p-dialog>
      <div style="width: 100%; display: flex; padding: 8px; ">
        <div style="width:30%;padding:8px">
          <div class="flight-card" style="margin-bottom: 8px; width: 100%; max-width: 100% !important;padding:7px;display:flex;flex-direction:column">
            <div style="display: flex;   font-size: 14px; width: 100%;flex-direction:column">
              <div style="font-weight:bold;padding:5px">Status:<span style="padding-left:4px;color:var(--first-color-second)">{{offlineObj.bookingStatusName}}</span> </div>
              <div style="font-weight: bold; padding: 5px">Requesting Agency:<span style="padding-left: 4px; color: var(--first-color-second)"> {{offlineObj.requestingAgency}}</span></div>
              <div style="font-weight: bold; padding: 5px">Requester Name:<span style="padding-left: 4px; color: var(--first-color-second)">{{offlineObj.requestingUserName}}</span> </div>
              <div style="font-weight: bold; padding: 5px">Booking Id: <span style="padding-left: 4px; color: var(--first-color-second)">{{offlineObj.offlineId}}</span></div>
              @if (offlineObj.pnr != null && offlineObj.pnr != '' && offlineObj.pnr != undefined) {
                <div style="font-weight: bold; padding: 5px">PNR: <span style="padding-left: 4px; color: var(--first-color-second)">{{offlineObj.pnr}}</span></div>
              }


            </div>

            <div style="width: 100%;">
              <!--<span *ngIf="request == 'Agent'" style="padding: 10px; font-weight: bold; display: flex; width: 100%; justify-content: center; padding-top: 0px ">Status Booking</span>-->
              <div style="display: flex; width: 100%; justify-content: center; gap: 5px">
                @if (request == 'Agent') {
                  <button class="button-42" (click)="UpdateOfflineRequest(5)">Invoiced</button>
                }
                @if (request == 'Agent') {
                  <button class="button-42" (click)="UpdateOfflineRequest(6)">Removed From List</button>
                }
                @if (request == 'Agent') {
                  <button class="button-42" (click)="showPopupTicketPassenger()">Ticketed</button>
                }
                @if (request == 'Agent') {
                  <button class="button-42" (click)="UpdateOfflineRequest(4)">Booked</button>
                }
                <button class="button-42" style="background:white;color:orangered" (click)="CheckROUTE()">Back To List</button>
              </div>
            </div>

          </div>
          <div style=" width: 100%;">
            <!--<div class="flight-card" style="margin-bottom: 8px">
            <span style="padding: 10px; font-weight: bold; display: flex; width: 100%; justify-content: center;padding-top:0px"> Offer Action</span>
            <div style="display:flex;width:100%;justify-content:center;gap:5px">
              <button class="button-42" style="width:100px">Approve</button>
              <button class="button-42"  style="width:100px">Reject</button>
            </div>
          </div>-->


          <div class="flight-card" style="margin-bottom: 8px">
            <div class="mb-2" style="display: flex; width: 100%; background-color: #d64161; justify-content: center; align-items: center; border-radius: 5px; padding: 4px">
              <span style="color:white;font-size:15px">Previous Flight Details</span>
            </div>
            <div class="row m-0">
              <div class="col-md-4 p-0 business" style="display:flex;flex-direction:column">

                <span style="font-size:12px;font-weight:bold">Ticket NO</span>
                <span style="font-size:11px;">{{offlineObj.reissueObj.previousTicketNo}}</span>

              </div>
              <div class="col-md-4 p-0 business" style="display:flex;flex-direction:column">

                <span style="font-size:12px;font-weight:bold">PNR</span>
                <span style="font-size:11px;">{{offlineObj.reissueObj.pnr}}</span>

              </div>
              <div class="col-md-4 p-0 business" style="display:flex;flex-direction:column">

                <span style="font-size:12px;font-weight:bold">Departure Date</span>
                <span style="font-size:11px;">{{offlineObj.reissueObj.departureDate}}</span>

              </div>
            </div>

          </div>

          <div class="flight-card">
            <div class="mb-2" style="display: flex; width: 100%; background-color: #feb236; justify-content: center; align-items: center; border-radius: 5px; padding: 4px">
              <span style="color:white;font-size:15px">New Flight Details</span>
            </div>
            <div class="departure-container">
              <div class="departure-label">{{offlineObj.tripType}}</div>
              <!--<div class="departure-date">26 Jun 2023</div>-->
            </div>
            <div class="header">
              <!--<div class="airline-info">
              <img src="https://via.placeholder.com/40" alt="Avianca Logo" class="airline-logo">
              <div>
                <h3 class="flight-number">AV 121</h3>
                <p class="airline-name">Avianca</p>
              </div>
            </div>-->
            <div class="extras">
              <div style="font-size:10px;display:flex;flex-direction:column;">
                <div style="font-size:10px;font-weight:bold">Criteria Filter</div>
                <div> @if (offlineObj.isLcc) {
                  <span style="color:green">✔️</span>
                  } @if (!offlineObj.isLcc) {
                  <span style="color:red">✖️</span>
                }Low cost</div>
                <div> @if (offlineObj.isGds) {
                  <span style="color:green">✔️</span>
                  } @if (!offlineObj.isGds) {
                  <span style="color:red">✖️</span>
                }GDS</div>

                <div> @if (offlineObj.isNearByAirport) {
                  <span style="color:green">✔️</span>
                  } @if (!offlineObj.isNearByAirport) {
                  <span style="color:red">✖️</span>
                }NearBy Airport</div>
                <div> @if (offlineObj.isDirect) {
                  <span style="color:green">✔️</span>
                  } @if (!offlineObj.isDirect) {
                  <span style="color:red">✖️</span>
                }Direct</div>
              </div>
              <div class="business" style="display:flex;flex-direction:column">

                <span style="font-size:10px;font-weight:bold">Fare Type</span>
                <span style="font-size:10px;">{{offlineObj.fareType}}</span>

              </div>
              <div class="business" style="display:flex;flex-direction:column">
                <span style="font-size:10px;font-weight:bold">Cabin Class</span>
                <span style="font-size:10px;">{{offlineObj.cabinClass}}</span>
              </div>
              <div class="bags" style="display:flex;flex-direction:column">
                <div style="font-size:10px;font-weight:bold">
                  Passengers:
                </div>
                <div style="font-size:10px;">
                  {{offlineObj.adult}} Adult
                </div>
                <div style="font-size:10px;">
                  {{offlineObj.child}} Child
                </div>
                <div style="font-size:10px;">
                  {{offlineObj.infant}} Infant
                </div>
              </div>
              <div class="bags" style="display:flex;flex-direction:column">
                <div style="font-size:10px;font-weight:bold">
                  Preffered Airlines:
                </div>
                @for (pref of offlineObj.prefferedAirlines; track pref) {
                  <div style="font-size:10px;">
                    {{pref}}
                  </div>
                }

              </div>
            </div>
          </div>

          @for (sec of offlineObj.sectorInfo; track sec; let i = $index) {
            <div class="card-new  p-3">
              <h6 class="text-muted" style="font-size: 13px;">DEPART</h6>
              <div class="d-flex justify-content-between align-items-center">
                <div class="text-start" style="width:40%">
                  <p class="mb-0 small text-muted">{{sec.departureDate | date:'y MMM d'  }}</p>
                  <h4 class="mb-0 fw-bold">{{sec.fromCity}}</h4>
                  <p class="mb-0 small">{{sec.fromAirport}}</p>
                </div>
                <div class="text-center" style="width:20%">
                  <svg viewBox="0 0 24 24" class="svgcardnew">
                    <path d="M14.1077 16L9.69346 20.4142C9.31839 20.7893 8.80968 21 8.27925 21H7.19346C6.86794 21 6.54807 20.9151 6.26544 20.7536C5.36851 20.241 5.05689 19.0984 5.56942 18.2015L6.84912 15.962C5.02029 15.7355 3.44263 14.5124 2.78382 12.7556L1.10825 8.28745C0.779947 7.41197 1.22352 6.4361 2.09901 6.10779C2.28909 6.03651 2.49045 6 2.69346 6H3.27925C3.80968 6 4.31839 6.21071 4.69346 6.58579L7.10767 9H7.82742L6.56942 6.7985C6.05689 5.90157 6.36851 4.75898 7.26544 4.24645C7.54807 4.08495 7.86794 4 8.19346 4H9.27925C9.80968 4 10.3184 4.21071 10.6935 4.58579L15.1077 9H19.1935C21.1265 9 22.6935 10.567 22.6935 12.5C22.6935 14.433 21.1265 16 19.1935 16H14.1077ZM8.82522 12.5039C9.09923 12.0243 9.71008 11.8577 10.1896 12.1318C10.6691 12.4058 10.8357 13.0166 10.5617 13.4961L7.41664 19H8.27925L14.9864 12.2929C15.3769 11.9024 16.01 11.9024 16.4006 12.2929C16.7911 12.6834 16.7911 13.3166 16.4006 13.7071L16.1077 14H19.1935C20.0219 14 20.6935 13.3284 20.6935 12.5C20.6935 11.6716 20.0219 11 19.1935 11H6.69346C6.42824 11 6.17389 10.8946 5.98635 10.7071L3.27925 8H3.13646L4.65647 12.0534C5.09557 13.2243 6.21493 14 7.46546 14H7.97028L8.82522 12.5039ZM10.1309 9H12.2792L9.27925 6H8.41664L10.1309 9Z"></path>
                  </svg>
                </div>
                <div class="text-end" style="width:40%">
                  <p class="mb-0 small text-muted">{{sec.departureDate | date:'y MMM d'  }}</p>
                  <h4 class="mb-0 fw-bold">{{sec.toCity}}</h4>
                  <p class="mb-0 small">{{sec.toAirport}}</p>
                </div>
              </div>
            </div>
          }
          <!--<div class="flight-details" *ngFor="let sec of offlineObj.sectorInfo;let i = index">
          <div class="flight-time">
            <p class="time">{{sec.fromCity}}</p>
            <p class="airport">{{sec.fromAirport}}</p>
            <p class="date">{{sec.departureDate | date:'y MMM d'  }}</p>
          </div>
          <div class="flight-duration">
            <div class="animation-container">
              <div class="airplane">✈️</div>
              <div class="dashed-line"></div>
            </div>-->
            <!--<p class="duration">10h 10m</p>-->
          <!--</div>
          <div class="flight-time">
            <p class="time">{{sec.toCity}}</p>
            <p class="airport">{{sec.toAirport}}</p>
            <p class="date">{{sec.departureDate | date:'y MMM d'}}</p>
          </div>
        </div>-->
      </div>
      @if (offlineObj.passengerList != null && offlineObj.passengerList.length > 0) {
        <div class="flight-card mt-2">
          <div class="mb-1" style="display: flex; width: 100%; background-color: #6b5b95; justify-content: center; align-items: center; border-radius: 5px; padding: 4px">
            <span style="color:white;font-size:15px">Travel Information</span>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Ticket No</th>
              </tr>
            </thead>
            <tbody>
              @for (passenger of offlineObj.passengerList; track passenger; let u = $index) {
                <tr>
                  <th scope="row">{{passenger.fullName}} ({{passenger.type}})</th>
                  <td>{{passenger.ticketNo}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

    </div>

  </div>
  <div style="width:70%;position:relative">
    <div style="max-height:80vh !important;height:80vh">
      <app-chat (dataToParent)="handleData($event)" [GettingUniqueData]="basicDataforChat"></app-chat>
    </div>
  </div>


</div>
</div>
